exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>\n */\n.danger {\n  color: #f86c6b; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/order-headers/order-headers-reject/order-headers-reject.component.scss
// module id = ../../../../../angular/app/views/order-headers/order-headers-reject/order-headers-reject.component.scss
// module chunks = main